module.exports = __webpack_public_path__ + "img/Ferimentos e aberturas naturais macieira - Queda de folhas 1.d9b965b6.webp";